import { type MRT_ColumnDef } from 'material-react-table';
import { deviceTableParams } from '../../../pages/inventoryTableQuery';
import { type DeviceRow } from '../../../pages/useInventoryTables';
import ServerTable, { type ServerTableProps } from './ServerTable';
import { idColumn, booleanColumn } from './tableColumns';

const columns: MRT_ColumnDef<DeviceRow>[] = [
  idColumn<DeviceRow>(),
  { accessorKey: 'name', header: 'Device Name', size: 260, filterFn: 'contains', muiFilterTextFieldProps: { placeholder: 'Contains…' } },
  { accessorKey: 'model', header: 'Model', size: 260, filterFn: 'contains', muiFilterTextFieldProps: { placeholder: 'Contains…' } },
  { accessorKey: 'h_factor', header: 'H Factor', size: 180, filterFn: 'equals', muiFilterTextFieldProps: { type: 'number', placeholder: 'Exact H Factor', slotProps: { htmlInput: { step: 'any' } } } },
  booleanColumn<DeviceRow>('ultra_wide', 'Ultra Wide'),
  booleanColumn<DeviceRow>('is_active', 'Status', 'Active', 'Inactive'),
];
export default function DeviceTable(props: ServerTableProps<DeviceRow>) {
  return <ServerTable {...props} columns={columns} title="Phone Configurations" recordLabel="phone configurations" searchPlaceholder="Search name or model"
    createLabel="Create Phone Configuration" rowTestKey={row => `name-${row.name}`} exportEndpoint="devices" exportParams={deviceTableParams} />;
}
